// extracted by mini-css-extract-plugin
export var carrierIcon = "_yf-0";
export var carrierLogo = "_yf-1";
export var detailsSection = "_yf-2";